import React, { useCallback, useMemo } from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import Radio from '../Radio'
import ErrorMessage from '../ErrorMessage'
import Chip from '../../../components/Chip'

import useStyles from './style'

function RadioBlock({
  children,
  selectedValue,
  setFieldValue,
  error,
  touched,
  badgeText,
  badgeColor,
  disabled,
  onValueChange,
  ...props
}) {
  const isChecked = selectedValue === props.value

  const classes = useStyles(isChecked)

  const hasChildren = useMemo(() => {
    if (children && children.length) {
      return children.find(item => !!item)
    } else {
      return !!children
    }
  }, [children])

  const onChange = useCallback(
    e => {
      const value = e.target.value
      setFieldValue(e.target.name, value)

      onValueChange && onValueChange(value)
    },
    [onValueChange, setFieldValue]
  )

  return (
    <div className={classnames('radioBlock', classes.radioBlock)}>
      <Radio disabled={disabled} checked={isChecked} onChange={onChange} {...props} />
      {hasChildren && isChecked && (
        <div className={classes.radioBody}>
          {children}
          {error && touched && <ErrorMessage error={error} />}
        </div>
      )}
      {badgeText && <Chip text={badgeText} isBadge isSmall color={badgeColor} showCircle={false} />}
    </div>
  )
}

RadioBlock.propTypes = {
  children: PropTypes.node,
  selectedValue: PropTypes.string,
  setFieldValue: PropTypes.func.isRequired,
  error: PropTypes.string,
  touched: PropTypes.bool,
  badgeText: PropTypes.string,
  badgeColor: PropTypes.string,
  disabled: PropTypes.bool
}

export default RadioBlock
